(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = document.getElementById(root.dataset.formId);
    if (!form) return;

    const choiceInputs = root.querySelectorAll('input[name^="personalization-choice-"]');
    const fields = root.querySelector('[data-personalization-fields]');
    const text = root.querySelector('[data-personalization-text]');
    const count = root.querySelector('[data-personalization-count]');
    const file = root.querySelector('[data-personalization-file]');
    const fileName = root.querySelector('[data-personalization-file-name]');
    const error = root.querySelector('[data-personalization-error]');
    const addChoice = root.querySelector('[data-personalization-choice="add"]');
    const noneChoice = root.querySelector('[data-personalization-choice="none"]');
    const propertyInputs = root.querySelectorAll('[name^="properties["]');

    const setError = (message) => {
      error.textContent = message || '';
      error.hidden = !message;
    };

    const syncState = () => {
      const personalized = root.querySelector('input[name^="personalization-choice-"]:checked')?.value === 'add';
      fields.hidden = !personalized;
      addChoice.classList.toggle('is-active', personalized);
      noneChoice.classList.toggle('is-active', !personalized);

      propertyInputs.forEach((input) => {
        input.disabled = !personalized;
      });
      setError('');
    };

    choiceInputs.forEach((input) => input.addEventListener('change', syncState));

    root.querySelectorAll('.product-personalization__method input').forEach((input) => {
      input.addEventListener('change', () => {
        root.querySelectorAll('.product-personalization__method').forEach((method) => method.classList.remove('is-selected'));
        input.closest('.product-personalization__method')?.classList.add('is-selected');
      });
    });

    root.querySelectorAll('.product-personalization__font input').forEach((input) => {
      input.addEventListener('change', () => {
        root.querySelectorAll('.product-personalization__font').forEach((font) => font.classList.remove('is-selected'));
        input.closest('.product-personalization__font')?.classList.add('is-selected');
      });
    });

    text?.addEventListener('input', () => {
      count.textContent = text.value.length;
    });

    file?.addEventListener('change', () => {
      const selected = file.files?.[0];
      fileName.textContent = '';
      if (!selected) return;

      const allowed = ['image/png', 'image/jpeg', 'application/pdf', 'image/svg+xml', 'application/postscript', 'application/illustrator'];
      const extension = selected.name.split('.').pop()?.toLowerCase();
      const allowedExtensions = ['png', 'jpg', 'jpeg', 'pdf', 'ai', 'svg'];
      if (!allowed.includes(selected.type) && !allowedExtensions.includes(extension)) {
        file.value = '';
        setError('Please upload a PNG, JPG, PDF, AI, or SVG file.');
        return;
      }
      if (selected.size > 10 * 1024 * 1024) {
        file.value = '';
        setError('The logo file must be 10 MB or smaller.');
        return;
      }
      fileName.textContent = selected.name;
      setError('');
    });

    form.addEventListener('submit', (event) => {
      const personalized = root.querySelector('input[name^="personalization-choice-"]:checked')?.value === 'add';
      if (!personalized) return;

      const hasText = text?.value.trim().length > 0;
      const hasLogo = file?.files?.length > 0;
      if (!hasText && !hasLogo) {
        event.preventDefault();
        setError('Please enter personalization details or upload a logo before adding this item to the cart.');
        text?.focus();
        return;
      }
    });

    syncState();
  };

  const boot = () => document.querySelectorAll('[data-product-personalization]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
